module.exports = __webpack_public_path__ + "img/phone.a6bb983f.png";